export enum LoaiPhieuNhapEnum {
  TAM_NHAP = 0,
  HOP_DONG_MUA_BAN = 1,
  HOP_DONG_DIEU_CHINH = 2
}
